module.exports = __webpack_public_path__ + "img/funding-options-icon.e85af12d.png";